const GenderIdentity = [{GenderIdentityID: 1, GenderIdentityDescription: 'Decline to Answer'},
{GenderIdentityID: 2, GenderIdentityDescription: 'Male'},
{GenderIdentityID: 3, GenderIdentityDescription: 'Female'},
{GenderIdentityID: 4, GenderIdentityDescription: 'Transgender Male'},
{GenderIdentityID: 5, GenderIdentityDescription: 'Transgender Female'}, 
{GenderIdentityID: 6, GenderIdentityDescription: 'Gender Queer'}]

export default GenderIdentity;